import React,{useContext} from 'react';
import { Switch, FormGroup, InputLabel, MenuItem, Checkbox, FormControlLabel, FormControl, TextField, TextareaAutosize } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { __ } from '@wordpress/i18n';
import Context from '../store/store';
const useStyles = makeStyles({
      margin: {
        marginBottom: '20px',
      },
});
const SecondStep = (props) => {
    const classes = useStyles();
    const ctx = useContext(Context);
    return ( 
    <>
        <h3 className="mwb-title">{__('Add To Cart Popup Setting','abandoned-cart-for-woocommerce') }</h3>
        <FormControlLabel
            control={
            <Switch
                checked={ctx.formFields['mwb_enable_atc_popup']}
                onChange={ctx.changeHandler}
                name="mwb_enable_atc_popup"
                color="primary"
                 />
            }
            label="Enable Add To Cart Popup"
            className={classes.margin} />
        <FormControl component="fieldset" variant="outlined" fullWidth className="fieldsetWrapper">
           
           
            <TextField 
                value={ctx.formFields['mwb_atc_title']}
                onChange={ctx.changeHandler} 
                id="mwb_atc_title" 
                name="mwb_atc_title" 
                label={__('Add to Cart Pop-Up Title','abandoned-cart-for-woocommerce') } 
                helperText={__('Enter title here to show on add to cart pop-up.','abandoned-cart-for-woocommerce') } 
                variant="outlined" className={classes.margin}/>
                 <TextareaAutosize
                 name="mwb_atc_text" 
                 value={ctx.formFields['mwb_atc_text']}
                 onChange={ctx.changeHandler}
                 aria-label="minimum height" 
                 minRows={4} placeholder={__('Add to Cart Pop-Up Text','abandoned-cart-for-woocommerce') } 
                variant="outlined" className={classes.margin}/>
        </FormControl>
    </>
    )
}
export default SecondStep;